module.exports = __webpack_public_path__ + "html/bodycodes.template.html";